/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 41,
  image: "default-changelog-v2.png",
  title: "Platform Fixes & Documentation Updates",
  shortDescription: "We have released a new version of the Spheron platform with a couple of fixes. Spheron DOCS now include details on how to deploy the Jupyter instance.",
  description: "We have released a new version of the Spheron platform with a couple of fixes. Spheron DOCS now include details on how to deploy the Jupyter instance.",
  date: "Aug 7th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron"]
};
export const content = `
## Platform Fixes
- **Login Connection Deletion:** Fixed an issue that was previously preventing the successful deletion of login connections.
- **IPFS Dedicated Gateways:** Resolved an issue that was causing the creation of IPFS dedicated gateways to fail.
- **Bandwidth Usage:** Improved bandwidth calculation for gateway links to ensure accurate measurement.

## Documentation Updates

Jupyter Notebook Cluster Instance: Added documentation outlining the step-by-step process for initiating a Jupyter Notebook cluster instance directly from the marketplace. For further details, please refer to the updated [DOCS](https://docs.spheron.network/marketplace-guide/jupyter/).
`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
